if(caffeineInterval) {
	var lastCheck = new Date();
	var caffeineSendDrip = function () {
		var ajax = window.XMLHttpRequest
			? new XMLHttpRequest
			: new ActiveXObject('Microsoft.XMLHTTP');
		ajax.onreadystatechange = function () {
			if (ajax.readyState === 4 && ajax.status === 204) {
				lastCheck = new Date();
			}
		};
		ajax.open('GET', caffeineRoute);
		ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		ajax.send();
	};
	console.log('START caffeineSendDrip()');
	setInterval(function () {
		caffeineSendDrip();
	}, caffeineInterval);
}



// WEBPACK FOOTER //
// ./resources/assets/js/caffeine.js